import { createContext, useContext, useState, useEffect } from 'react';

const THEME_KEY = 'lp-theme';

const dark = {
  bg: '#0D0D0F',
  bgCard: '#161619',
  bgInput: '#1E1E22',
  bgSidebar: '#0A0A0C',
  bgHover: 'rgba(255,255,255,0.04)',
  bgElevated: '#1E1E22',
  bgModal: '#161619',
  bgSunken: '#08080A',
  text: '#FFFFFF',
  textSecondary: 'rgba(255,255,255,0.65)',
  textMuted: 'rgba(255,255,255,0.40)',
  textOnDark: '#ffffff',
  border: 'rgba(255,255,255,0.08)',
  borderLight: 'rgba(255,255,255,0.05)',
  borderStrong: 'rgba(255,255,255,0.14)',
  shadow: '0 1px 3px rgba(0,0,0,0.4)',
  shadowLg: '0 8px 32px rgba(0,0,0,0.5)',
  accent: '#4ADE80',
  accentHover: '#6AEEA0',
  accentMuted: 'rgba(74,222,128,0.12)',
  accentSubtle: 'rgba(74,222,128,0.06)',
};

const light = {
  bg: '#F5F5F7',
  bgCard: '#FFFFFF',
  bgInput: '#F0F0F2',
  bgSidebar: '#EBEBED',
  bgHover: 'rgba(0,0,0,0.03)',
  bgElevated: '#FFFFFF',
  bgModal: '#FFFFFF',
  bgSunken: '#E8E8EA',
  text: '#1A1A1A',
  textSecondary: 'rgba(0,0,0,0.55)',
  textMuted: 'rgba(0,0,0,0.35)',
  textOnDark: '#ffffff',
  border: 'rgba(0,0,0,0.10)',
  borderLight: 'rgba(0,0,0,0.06)',
  borderStrong: 'rgba(0,0,0,0.16)',
  shadow: '0 1px 3px rgba(0,0,0,0.08)',
  shadowLg: '0 8px 32px rgba(0,0,0,0.12)',
  accent: '#16A34A',
  accentHover: '#15803D',
  accentMuted: 'rgba(22,163,74,0.10)',
  accentSubtle: 'rgba(22,163,74,0.05)',
};

export const THEMES = { light, dark };

const ThemeCtx = createContext({ theme: dark, isDark: true, toggle: () => {} });

export function useTheme() { return useContext(ThemeCtx); }

function loadPref() {
  try { return localStorage.getItem(THEME_KEY) === 'light' ? false : true; } catch { return true; }
}

export function ThemeProvider({ children }) {
  const [isDark, setIsDark] = useState(loadPref);
  const theme = isDark ? dark : light;

  const toggle = () => setIsDark(d => {
    const next = !d;
    try { localStorage.setItem(THEME_KEY, next ? 'dark' : 'light'); } catch {}
    return next;
  });

  useEffect(() => {
    document.body.style.background = theme.bg;
    document.body.style.color = theme.text;
    document.body.style.transition = 'background 0.3s, color 0.3s';
    document.documentElement.setAttribute('data-theme', isDark ? 'dark' : 'light');
  }, [isDark, theme]);

  return <ThemeCtx.Provider value={{ theme, isDark, toggle }}>{children}</ThemeCtx.Provider>;
}
